import React from 'react'
import { Button, ButtonProps } from 'grommet'

const ArrowButton: React.FC<ButtonProps> = (props) => {
  return <Button {...props} color="brand" plain />
}

export default ArrowButton
